// THIS FILE IS AUTOMATICALLY GENERATED. DO NOT MODIFY IT MANUALLY.

import { THEME_NAME, THEME_MODE } from '../../../symbol';

import baseTheme from '../../trellis/light/theme';

export type ThemeName = 'lavender';

export type ThemeMode = 'light';

/**
 * Design System theme object.
 *
 * Theme name: `lavender`
 *
 * Theme mode: `light`
 */
const theme = {
  ...baseTheme,
  color: {
    ...baseTheme.color,
    'fwc-button-fill-primary-default': '#e74100',
  },
};

Object.assign(theme, {
  [THEME_NAME]: 'lavender',
  [THEME_MODE]: 'light',
});

export default theme;
